/* eslint-disable no-undef */
/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { Tile, Spot } from '@paypalcorp/pp-react';
import ContactCardContainer from './ContactCardContainer';
import Page from '../../../lib/page';

/**
 * Re-usable Component for contact option card
 */
const ContactCardComponent = function (props) {
  const { contactSize, contactLabel, contactType, contactTarget, contactUrl, contactDescription } = props;
  let contactCardSize = contactSize;

  // eslint-disable-next-line consistent-return
  const getSpotName = (contactType) => {
    if (contactType === 'resolution') {
      return 'human-services';
    }
    if (contactType === 'community') {
      return 'community';
    }
    if (contactType === 'message-center') {
      return 'message';
    }
  };

  // Resolve promoted links on HC homepage for longer languages, including, Germany, Italian, Russian
  if (Page.getCountry() === 'de' || Page.getCountry() === 'it' || Page.getCountry() === 'ru') {
    contactCardSize = 'lg';
  }

  const icon = <Spot name={getSpotName(contactType)} className="contact-card--contact-icon" aria-hidden="true" />;
  return (
    <Tile
      card
      cardRadius="lg"
      className={`contact-card contact-card--sh-card-${contactCardSize}`}
      id={`new-hero-${contactType}-link`}
      // eslint-disable-next-line react/jsx-no-bind
      onClick={(e) => ContactCardContainer.clickHandler(e, props)}
    >
      {icon}
      <div className="contact-card--label-description-icon-container">
        <div className="contact-card--contact-labels">
          <a aria-label={contactDescription} rel="noopener noreferrer" href={contactUrl} target={contactTarget}>
            {contactLabel}
          </a>
        </div>
        <div className="contact-card--contact-description">{contactDescription}</div>
      </div>
    </Tile>
  );
};

ContactCardComponent.propTypes = {
  contactLabel: PropTypes.string,
  contactDescription: PropTypes.string,
  contactType: PropTypes.string,
  contactTarget: PropTypes.string,
  contactUrl: PropTypes.string,
  contactSize: PropTypes.string,
};

ContactCardComponent.defaultProps = {
  contactSize: 'auto',
  contactLabel: '',
  contactDescription: '',
  contactType: '',
  contactTarget: '_self',
  contactUrl: '',
  contactNewTab: false,
};

export default ContactCardComponent;
